'use client'

import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './carousel.module.scss'

interface CarouselArrowsProps {
  carouselId: string
}

const CarouselArrows: React.FC<CarouselArrowsProps> = ({ carouselId }) => {
  const handleLeftArrow = () => {
    const carouselContainer: any = document.querySelector(`.carousel-${carouselId}`)
    const cardWidth: any = document.getElementById('carousel-card-0')?.getBoundingClientRect().width

    const gap = Number(window.getComputedStyle(carouselContainer).gap.split('px')[0])

    if (carouselContainer) {
      carouselContainer.scrollBy({
        left: -cardWidth - gap,
        behavior: 'smooth',
      })
    }
  }

  const handleRightArrow = () => {
    const carouselContainer: any = document.querySelector(`.carousel-${carouselId}`)
    const cardWidth: any = document.getElementById('carousel-card-0')?.getBoundingClientRect().width

    const gap = Number(window.getComputedStyle(carouselContainer).gap.split('px')[0])

    if (carouselContainer) {
      carouselContainer.scrollBy({
        left: cardWidth + gap,
        behavior: 'smooth',
      })
    }
  }

  return (
    <div className={styles.CarouselArrows}>
      <button onClick={handleLeftArrow} type="button">
        <Image
          src={`${assetLoader()}/images/carousel-arrow-left.svg`}
          alt="Carousel Left Arrow"
          width={48}
          height={48}
          loading="lazy"
        />
      </button>
      <button onClick={handleRightArrow} type="button">
        <Image
          src={`${assetLoader()}/images/carousel-arrow-right.svg`}
          alt="Carousel Right Arrow"
          width={48}
          height={48}
          loading="lazy"
        />
      </button>
    </div>
  )
}

export default CarouselArrows
